import { RadioGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekRadioGroup = styled(RadioGroup)(({}) => ({}));

export { PeekRadioGroup, PeekRadioGroup as default };
